var map = {
	"./4D_Icon.svg": 429,
	"./4d-result-icon-white.svg": 959,
	"./4d-result-icon.svg": 417,
	"./93Connect_desktop.svg": 960,
	"./Add_Icon.svg": 167,
	"./All.svg": 961,
	"./Casino.svg": 962,
	"./Connect.svg": 963,
	"./Dashboard_Reward.svg": 420,
	"./FattyPay.svg": 964,
	"./FattyPay_DuitNow_Mobile.svg": 965,
	"./FattyPay_DuitNow_app.svg": 966,
	"./Fish Games.svg": 967,
	"./InCasino.svg": 968,
	"./InConnect.svg": 969,
	"./InLottery.svg": 970,
	"./InPoker.svg": 971,
	"./InRNG.svg": 972,
	"./InSlots.svg": 973,
	"./InSports.svg": 974,
	"./InVirtual-Sports.svg": 975,
	"./IneSports.svg": 976,
	"./Lottery.svg": 977,
	"./Minus_Icon.svg": 168,
	"./New-top-right.svg": 251,
	"./Poker.svg": 978,
	"./RNG.svg": 979,
	"./SPG.svg": 980,
	"./SPG_QR.svg": 981,
	"./SPG_QR_WH.svg": 982,
	"./SPG_QR_app.svg": 983,
	"./Slots.svg": 984,
	"./Sports.svg": 985,
	"./Truemoney_horizontal.svg": 986,
	"./Truemoney_vertical.svg": 987,
	"./VaderPay.svg": 988,
	"./VaderPay_QR.svg": 989,
	"./VaderPay_QR_WH.svg": 990,
	"./VaderPay_app.svg": 991,
	"./account-icon.svg": 992,
	"./android-icon.svg": 993,
	"./blue-background-modern.svg": 433,
	"./bonus-report-icon.svg": 994,
	"./cash-icon.svg": 995,
	"./cash-withdrawal-icon.svg": 996,
	"./commission-report-icon.svg": 997,
	"./contact-us-icon-yellow.svg": 281,
	"./contact-us-icon.svg": 998,
	"./copy-icon.svg": 999,
	"./custom-checkbox-1-checked.svg": 268,
	"./custom-checkbox-1-unchecked.svg": 269,
	"./custom-checkbox-modern-1-checked.svg": 434,
	"./custom-checkbox-modern-1-unchecked.svg": 435,
	"./dashboard-logout.svg": 258,
	"./downline-account.svg": 1000,
	"./downline-icon-white.svg": 430,
	"./downline.svg": 1001,
	"./downlines-icon.svg": 418,
	"./eSports.svg": 1002,
	"./game-report-icon.svg": 1003,
	"./game.svg": 415,
	"./games-icon.svg": 1004,
	"./goldMinus.svg": 170,
	"./goldPlus.svg": 169,
	"./heart-all-icon.svg": 1005,
	"./hot-top-right.svg": 177,
	"./ionic-ios-add-circle-outline.svg": 165,
	"./ionic-ios-minus-circle-outline.svg": 166,
	"./kpi-icon.svg": 282,
	"./live-chat.svg": 1006,
	"./maintenance.svg": 436,
	"./mobile.svg": 431,
	"./money-bag.svg": 259,
	"./notification-icon-unread.svg": 423,
	"./notification-icon.svg": 424,
	"./phonebook-icon.svg": 1007,
	"./point-icon.svg": 1008,
	"./prize-package-icon.svg": 1009,
	"./provider-um-icon.svg": 1010,
	"./referral-icon.svg": 419,
	"./reload-icon-white.svg": 426,
	"./reload-icon.svg": 413,
	"./reports-icon-white.svg": 428,
	"./reports-icon.svg": 416,
	"./reset_password.svg": 178,
	"./result-icon.svg": 1011,
	"./right-menu-contact-us-icon.svg": 263,
	"./right-menu-home-icon.svg": 1012,
	"./right-menu-logout-icon.svg": 267,
	"./right-menu-notification-icon.svg": 260,
	"./right-menu-profile-icon.svg": 1013,
	"./right-menu-promotion-icon.svg": 205,
	"./right-menu-ranking-event-icon.svg": 266,
	"./right-menu-referral-icon.svg": 283,
	"./right-menu-settings-icon.svg": 265,
	"./right-menu-tnc-icon.svg": 264,
	"./right-menu-video-tutorial-icon.svg": 261,
	"./right-menu-vip-icon.svg": 262,
	"./right-menu-wallet-icon.svg": 1014,
	"./rollover-report-icon.svg": 1015,
	"./settings-icon.svg": 421,
	"./shareholder-icon.svg": 1016,
	"./star.svg": 422,
	"./ticket-icon.svg": 1017,
	"./tnc-icon.svg": 425,
	"./top-up-icon.svg": 1018,
	"./transfer-icon-white.svg": 427,
	"./transfer-icon.svg": 414,
	"./truepay.svg": 1019,
	"./truepayWhite.svg": 1020,
	"./under_maintenance.svg": 176,
	"./vid-tutorial-icon.svg": 280,
	"./wallet-stmt-icon.svg": 1021,
	"./wallet.svg": 1022,
	"./world_cup/diamond.svg": 1023,
	"./xmas-background-modern-lowerOpac.svg": 437,
	"./xmas-background-modern.svg": 438
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 432;